function sanitizeFilename(filename: string) {
  return filename.replace(/[^-\w]+/gi, '_');
}

/** Strips a lone surrogate at either end: half a pair cut by a code-unit slice; invalid JSON. */
function trimLoneSurrogates(text: string) {
  return text.replace(/^[\uDC00-\uDFFF]/, '').replace(/[\uD800-\uDBFF]$/, '');
}

export {sanitizeFilename, trimLoneSurrogates};
